export default __webpack_public_path__ + "static/media/corporate9.0ee0fba2.jpg";